// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2Tvps","Success":"Button_Success__37wk3","Danger":"Button_Danger__1tpY7"};